// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-tanzania/calculator-tanzania-business-loan/calculator-tanzania-business-loan.component.scss
// module id = 652
// module chunks = 0